import Vue from 'vue'
import Resizer from 'v-resize-observer'

Vue.use(Resizer) // use is a static method
